import React, { Fragment, useEffect } from 'react'
import ViewAllLayout from './ViewAllLayout'
import { useAuthState } from 'packages/core'
import useSubcomponents from 'useSubcomponents'
import { usePageContext } from 'pageContext'
import appConfiguration from 'appConfiguration'

const RequestViewAllCsvInbox = () => {
    const [, dispatch] = usePageContext()
    const [{ currentUserId, friendlyName }] = useAuthState()

    const { trimControlsBasedOnAccess } = useSubcomponents()

    const filters = trimControlsBasedOnAccess(
        appConfiguration?.applications?.filters,
    )
    const hasOwnedByFilterAccess =
        filters.map((f) => f.name).indexOf('OwnedByFilter') >= 0
    // useEffect(() => {
    //     if (!hasOwnedByFilterAccess) {
    //         dispatch({
    //             type: 'SET_MULTIPLE_PROPS',
    //             payload: {
    //                 ownedBy: {
    //                     id: currentUserId,
    //                     friendlyName: friendlyName,
    //                 },
    //                 enableOwnedByApiCall: true,
    //             },
    //         })
    //     } else {
    //         dispatch({
    //             type: 'SET_PROP',
    //             payload: {
    //                 key: 'enableOwnedByApiCall',
    //                 value: true,
    //             },
    //         })
    //     }
    // }, [currentUserId])

    return (
        <Fragment>
            <ViewAllLayout _filters={filters} />
        </Fragment>
    )
}

export { RequestViewAllCsvInbox }
